import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=1a44cbdb&"
import script from "./FollowUp.vue?vue&type=script&lang=ts&"
export * from "./FollowUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a44cbdb')) {
      api.createRecord('1a44cbdb', component.options)
    } else {
      api.reload('1a44cbdb', component.options)
    }
    module.hot.accept("./FollowUp.vue?vue&type=template&id=1a44cbdb&", function () {
      api.rerender('1a44cbdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/ward/discharge/FollowUp.vue"
export default component.exports